import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function ProjectsPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>
          Projektowanie | IKSEL Studio Reklamy - Reklama dla Twojej firmy
        </title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Opis naszych metod dotyczących projektowania, zasady i istnotne wskazówki, na co zwracać uwagę przy projektach. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="projektowanie-grafiki"
          title="Projektowanie grafiki"
          subtitle="Każdy nasz projekt jest unikalny"
          html={`
          <h3>Proces projektowania</h3>

          <p>Nasza Firma pracuje na najnowszym systemie technologii graficznej bez przerwy uaktualnianym, dajemy Państwu gwarancje najwyższych usług. W przypadku powierzenia nam swojego projektu otrzymujecie Państwo gwarancję profesjonalnego wykonania. Nasza firma nie korzysta z gotowych projekt&oacute;w, a każdy projekt traktowany jest indywidualnie. Oferta obejmuje projekty m.in. na:</p>
          
          <ul>
            <li>ulotki</li>
            <li>banery</li>
            <li>grafika na samoch&oacute;d</li>
            <li>wizyt&oacute;wki</li>
            <li>kalendarze</li>
            <li>broszury</li>
            <li>druki firmowe</li>
            <li>opakowania</li>
            <li>okadki</li>
            <li>foldery</li>
            <li>gadżety</li>
          </ul>
          
          <h3>Logo firmowe</h3>
          
          <p>Nasza firma stworzy dla Państwa oryginalny i niepowtarzalny wizerunek Twojej firmy. W zależności od tego czy potrzebujesz nietypowe i ekstrawaganckie logo, proste czy takie kt&oacute;re będzie się rzucać w oczy nasi graficy wykonają kilka wzor&oacute;w odpowiadających Państwa potrzebom.</p>
          
          <p>Sprostamy każdemu wyzwaniu gdyż pracujący u nas graficy podchodzą z pasją do każdego projektu czyniąc go unikalnym.</p>
          
          <p>Zaufaj profesjonalistom, strzeż się firm kt&oacute;re oferując niską ceną kopiują już istniejące projekty co potem wiąże się z konsekwencjami prawnymi i wysokimi kosztami ugodowo-procesowymi!</p>
          
          <p>Nasi graficy dokonają dla Państwa bezpłatne korekty według Państwa potrzeb, aż do uzyskania satysfakcji!</p>
          
          <h3>Teksty reklamowe</h3>
          
          <p>Dzięki wieloletniemu doświadczeniu wiemy, że odpowiednio dobrane słowa potrafią kreować decyzje i wybory odbiorc&oacute;w oraz być budulcem pozytywnego wizerunku firmy, marki czy produktu.</p>
          
          <h3>Oferta:</h3>
          
          <ul>
            <li>hasła i slogany reklamowe</li>
            <li>nazwy własne np. firm, instytucji, marek i inne</li>
            <li>teksty reklam prasowych</li>
            <li>teksty na broszurki, ulotki, katalogi reklamowe itp.</li>
            <li>scenariusze spot&oacute;w telewizyjnych</li>
            <li>treść e-mailing&oacute;w</li>
            <li>teksty Public Relations</li>
            <li>SeoCopywriting</li>
          </ul>
          
          <h3>Strony internetowe</h3>
          
          <p>Świadczymy także usługi projektowania stron internetowych. Czym nasze projekty r&oacute;żnią się od innych?</p>
          
          <p>Oto kilka przykład&oacute;w:</p>
          
          <ul>
            <li>Każdy nasz projekt jest unikalny.</li>
            <li>Nasze ceny są niższe niż konkurencyjnych firm, ponieważ zatrudniamy profesjonalnych grafik&oacute;w a nie zlecamy projekty innym firmom!</li>
            <li>Nasze strony oparte są na nowoczesnych rozwiązaniach a zarazem są łatwe w nawigowaniu, dzięki czemu są przejrzyste i intuicyjne.</li>
            <li>Perfekcyjną optymalizacja SEO</li>
          </ul>
          `}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default ProjectsPage;
